import { runInAction } from "mobx"
import { useContext } from "react"

import { Button } from "@/components/Button/Button.tsx"
import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { Horizontal } from "@/components/Flex.ts"
import { Icon20, OpenInNewTabRegular } from "@/icons/Icons.ts"
import { openLinkInNewWindow } from "@/lib/std.ts"
import { TaskViewModelContext } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"

import type { ChatMessageModel } from "@/components/Chat/ChatModel.ts"
import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"

export const PersonalTokenFormMessage = (props: {
  message: ChatMessageModel
  content: AiChatMessageContent.InitProject.PersonalTokenForm
}) => {
  const taskViewModel = useContext(TaskViewModelContext)

  const helpClickHandler = () => {
    if (!taskViewModel) {
      return
    }
    const inputModel = taskViewModel.inputModel
    const inputModes = inputModel.supportedInputModes.get().map(it => it.type)
    if (inputModes.includes("Chat")) {
      inputModel.setInputMode("Chat")
      runInAction(() => {
        inputModel.firstInputValue.set("Tell me how to generate a token")
        if (inputModel.canSubmit.get()) {
          void inputModel.doSubmit()
        }
      })
    }
  }

  return (
    <AgentMessageContainer isActive={props.message.active}>
      <Horizontal gap="16px">
        <Button kind="secondary" onClick={() => openLinkInNewWindow(props.content.tokenUrl)}>
          <Horizontal alignItems="center" gap="4px">
            <OpenInNewTabRegular className={Icon20} />
            Get access token
          </Horizontal>
        </Button>

        {taskViewModel && (
          <Button kind="secondary" onClick={helpClickHandler}>
            How to generate a token?
          </Button>
        )}
      </Horizontal>
    </AgentMessageContainer>
  )
}
